import React from 'react';
import BrandTagRequestList from '../BrandTagRequestList';

const BrandTagRequestListWrap = (props) => {
  const { brandList, getList, getExcelDownload, getBrandTagColumnTagList } = props;

  return (
    <div>
      <BrandTagRequestList
        brandList={brandList}
        getList={getList}
        getExcelDownload={getExcelDownload}
        getBrandTagColumnTagList={getBrandTagColumnTagList}
      />
    </div>
  );
};

export default BrandTagRequestListWrap;
